<script setup lang="ts">
import { getBaseUrl } from "~/libraries/utility";
import { checkPoupCookie, isShowThemeSelector } from "~/shared/util";
import type { ThemeType } from "./shared/enum";

// import { getTitle } from './libraries/utility';

const route = useRoute();
const { cookieThemeType, setThemeType } = useTheme();
const {
    isSingupModal,
    setBonusDividend,
    setProhibitedDividend,
    setMaxDividend,
    setAlert,
    setIsPopupShow,
    isPopupShow,
    themeSetting,
    setSignupSetting,
    isMaintenance,
    setSportsCombination,
    setSingleBetPenalty,
    setThemeSetting,
    setVsportsSetting,
    isCouponRollingModal,
    couponRollingDetails,
    setIsCouponRollingModal,
} = useStore();
const { login, authentication, principal, isAuthenticated, setPrincipal, logout } = usePrincipal();
const isPromiseLoading = ref(true);
const popupList = ref<any>([]);

usePush();

// 자동 로그아웃 관련 변수
const inactiveLogoutTime = ref<number>(120); // 기본값 120분
const events = ["click", "mousemove", "mousedown", "scroll", "keydown", "load"];
let logOutTimer: any;

isPromiseLoading.value = true;
Promise.all([
    useBaseFetch("/setting/sports-bonus-dividend"),
    useBaseFetch("/setting/sports-prohibited-dividend"),
    useBaseFetch("/setting/sports-max-dividend"),
    useBaseFetch("/setting/signup-verify"),
    useBaseFetch("/setting/signup-referral-code"),
    useBaseFetch("/setting/signup"),
    useBaseFetch("/setting/sports-combination"),
    useBaseFetch<any>("/setting/config"),
    useBaseFetch<any>("/setting/vsports"),
    useBaseFetch<any>("popup"),
    useBaseFetch<any>("/setting"), // 자동 로그아웃 설정을 위한 전체 설정 조회
]).then(
    ([
        { data: bonusDividend },
        { data: prohibitedDividend },
        { data: maxDividend },
        { data: isMobileVerify },
        { data: isReferCode },
        { data: isPossibleSignup },
        { data: combination },
        { data: themeInfo },
        { data: vsports },
        { data: popups },
        { data: serverSetting },
    ]) => {
        setBonusDividend(bonusDividend);
        setProhibitedDividend(prohibitedDividend);
        setMaxDividend(maxDividend);
        setSignupSetting({
            isMobileVerify: isMobileVerify.value === "true",
            isReferCode: isReferCode.value === "true",
            isPossibleSignup: isPossibleSignup.value === "true",
        });
        setSportsCombination(combination.value);
        setThemeSetting(themeInfo.value);
        setVsportsSetting(vsports.value);

        // 자동 로그아웃 설정값 적용
        if (serverSetting.value?.user?.inactive_logout_time) {
            inactiveLogoutTime.value = serverSetting.value.user.inactive_logout_time;
            console.log(`자동 로그아웃 시간 설정: ${inactiveLogoutTime.value}분`);
        }

        if (!isShowThemeSelector()) {
            setThemeType(`sample${themeInfo.value.theme}` as ThemeType);
        }

        useHead({
            title: themeSetting.value.title,
            bodyAttrs: {
                class: "sample5",
            },
        });
        isPromiseLoading.value = false;

        for (const popup of popups.value) {
            if (!checkPoupCookie("popupId_" + popup._id)) {
                popupList.value.push(popup);
                setIsPopupShow(true);
            }
        }

        // if (checkPoupCookie('popupId')) {
        //   setIsPopupShow(false)
        // } else {
        //   setIsPopupShow(true);
        // }
    },
);

// const [{ data: bonusDividend }, { data: prohibitedDividend }, { data: isMobileVerify }, { data: isReferCode }, { data: isPossibleSignup }, { data: combination }, { data: themeInfo } ] = await Promise.all([
//     useBaseFetch('/setting/sports-bonus-dividend'),
//     useBaseFetch('/setting/sports-prohibited-dividend'),
//     useBaseFetch('/setting/signup-verify'),
//     useBaseFetch('/setting/signup-referral-code'),
//     useBaseFetch('/setting/signup'),
//     useBaseFetch('/setting/sports-combination'),
//     useBaseFetch<any>('/setting/config'),
// ]);

// setBonusDividend(bonusDividend);
// setProhibitedDividend(prohibitedDividend);
// setSignupSetting({
//   isMobileVerify: isMobileVerify.value === 'true',
//   isReferCode: isReferCode.value === 'true',
//   isPossibleSignup: isPossibleSignup.value === 'true'
// })
// setSportsCombination(combination.value);
// setThemeSetting(themeInfo.value);

// if (!isShowThemeSelector()) {
//   setThemeType(`sample${themeInfo.value.theme}` as ThemeType);
// }

// useHead({
//   title: themeSetting.value.title,
//   bodyAttrs: {
//     class: !isShowThemeSelector() ? `sample${themeInfo.value.theme}` : cookieThemeType
//   }
// });

let refreshTokenInterval: any = null;
const refreshToken = async () => {
    try {
        const { data, error: _aerror } = await useFetchWithCredentials<any>("auth/token", { isLoading: false });
        if (data.value) {
            const { token, ...user } = data.value as any;
            login({ jwt: token, principal: user });
            console.log("토큰 갱신 성공");
        } else if (_aerror.value) {
            console.error("토큰 갱신 실패:", _aerror.value);
            // 401 에러인 경우 로그아웃 처리
            if (_aerror.value.statusCode === 401) {
                console.log("토큰 만료로 인한 자동 로그아웃");
                logout();
                navigateTo("/");
            }
        }
    } catch (error) {
        console.error("토큰 갱신 중 예외 발생:", error);
    }
};

if (authentication.value.authenticated) {
    const { data: singleBetPenalty } = await useFetchWithCredentials("/setting/sports-single-penalty");
    setSingleBetPenalty(singleBetPenalty);
    refreshToken();
    if (refreshTokenInterval) {
        clearInterval(refreshTokenInterval);
    }
    // 10분마다 토큰 갱신 (서버 만료 시간 2시간의 1/12)
    refreshTokenInterval = setInterval(refreshToken, 10 * 60 * 1000);
}

// 자동 로그아웃 타이머 설정 함수
const setTimer = () => {
    if (logOutTimer) {
        clearTimeout(logOutTimer);
    }

    logOutTimer = setTimeout(
        () => {
            if (isAuthenticated.value) {
                console.log(`${inactiveLogoutTime.value}분 비활성으로 인한 자동 로그아웃`);
                logout();
                setAlert({
                    isShow: true,
                    data: {
                        type: "warning",
                        message: `${inactiveLogoutTime.value}분 동안 미사용으로 로그아웃 되었습니다`,
                    },
                });
                navigateTo("/");
            }
        },
        inactiveLogoutTime.value * 60 * 1000,
    );
};

// 타이머 리셋 함수
const resetTimer = () => {
    if (isAuthenticated.value) {
        clearTimeout(logOutTimer);
        setTimer();
    }
};

watch(
    () => authentication.value.authenticated,
    (current, previous) => {
        console.log(`authenticated status change :: ${previous}----------->>>${current}`);
        if (previous != current && current == true) {
            // 로그인 시 토큰 갱신 인터벌 시작
            if (refreshTokenInterval) {
                clearInterval(refreshTokenInterval);
            }
            refreshTokenInterval = setInterval(refreshToken, 10 * 60 * 1000);

            // 로그인 시 자동 로그아웃 타이머 시작
            setTimer();
        } else {
            console.log("cleared refreshtoken interval and logout timer");
            // 로그아웃 시 모든 타이머 정리
            if (refreshTokenInterval) clearInterval(refreshTokenInterval);
            if (logOutTimer) clearTimeout(logOutTimer);
        }
    },
);

watch(
    () => principal?.value?.unreadMessageCount,
    (count) => {
        if (authentication.value.authenticated && Number(count) > 0 && route.path != "/mypage/message") {
            setAlert({
                isShow: true,
                type: "unread-message",
                data: {
                    type: "warning",
                    message: "읽지않은 메세지가 있습니다.",
                },
            });
        }
    },
    { deep: true },
);

const authenticationState = useAuthentication();

let casinoRefreshTimerId: NodeJS.Timeout = 0;

const refreshCasinoMoney = async () => {
    try {
        const fetchData = await $fetch(`${getBaseUrl()}/auth/refreshCasinoMoney`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                source: route.fullPath,
                Authorization: `Bearer ${authenticationState.value.jwt}`,
            },
        });

        const { casino } = fetchData;

        setPrincipal({
            ...principal.value,
            casino: casino,
        });
    } catch (error) {
        console.error("Error while fetching casino money", error);
        return;
    }
};

await refreshCasinoMoney();

onMounted(() => {
    // 로그인 상태인 경우 자동 로그아웃 타이머 시작
    if (isAuthenticated.value) {
        setTimer();
    }

    // 사용자 활동 감지 이벤트 리스너 등록
    events.forEach(function (event) {
        window.addEventListener(event, () => {
            resetTimer();
        });
    });

    if (casinoRefreshTimerId) {
        clearInterval(casinoRefreshTimerId);
    }

    casinoRefreshTimerId = setInterval(async () => {
        if (principal.value && isAuthenticated.value && authentication.value.authenticated) {
            await refreshCasinoMoney();
        } else {
            console.log("User is not authenticated, skipping API call");
        }
    }, 5000);
});
onUnmounted(() => {
    // 모든 타이머 정리
    if (refreshTokenInterval) {
        clearInterval(refreshTokenInterval);
    }

    if (casinoRefreshTimerId) {
        clearInterval(casinoRefreshTimerId);
    }

    if (logOutTimer) {
        clearTimeout(logOutTimer);
    }

    // 이벤트 리스너 정리
    events.forEach(function (event) {
        window.removeEventListener(event, resetTimer);
    });
});
</script>
<template>
    <NuxtLoadingIndicator />
    <Spinner />
    <template v-if="isPromiseLoading">
        <Skeleton />
    </template>
    <template v-else>
        <template v-if="isMaintenance.isShow">
            <Maintenance />
        </template>
        <template v-else>
            <Alert />
            <ModalSignin />
            <ModalSignup v-if="isSingupModal" />
            <ModalCouponRolling
                v-if="isCouponRollingModal && couponRollingDetails"
                :details="couponRollingDetails"
                @close="setIsCouponRollingModal(false)"
            />
            <Popup v-if="isPopupShow" :data="popupList" />
            <NuxtLayout />
        </template>
    </template>
</template>
